import {
    addLastVisitedToStorage
} from '../CommonJs/locationStorage.js';
import { pushDataLayerEvent } from '../CommonJs/dataLayer.js';

try {
    if (typeof siteCurrentArea != "undefined") {
        // We have a location add it to localstorage
        addLastVisitedToStorage(siteCurrentArea);
    }
} catch (error) {
    console.log(error);
}

const toggleLink = document.querySelector('.link-to-24h');

// Add a click event listener to the toggle link
if (toggleLink) {
    toggleLink.addEventListener('click', function (event) {
        pushDataLayerEvent({
            event: 'timeframe_toggle',
            click_name: '24_hours'
        });
    });
}